module.exports = __webpack_public_path__ + "static/austin-3014046ed0c6c6ca05b697d1a354de55.jpg";